// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  matchId: __t.string().name("match_id"),
  sourceUnitId: __t.string().name("source_unit_id"),
  armyIndex: __t.u32().name("army_index"),
  x: __t.f64(),
  y: __t.f64(),
  targetUnitId: __t.string().name("target_unit_id"),
  targetX: __t.f64().name("target_x"),
  targetY: __t.f64().name("target_y"),
  speed: __t.f64(),
  delivered: __t.bool(),
  cancelled: __t.bool(),
  intercepted: __t.bool(),
  orderType: __t.string().name("order_type"),
  orderJson: __t.string().name("order_json"),
  orderQueueJson: __t.string().name("order_queue_json"),
});
